import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'react-icons-kit';
import { ic_add_box } from 'react-icons-kit/md/ic_add_box';
import { ic_search } from 'react-icons-kit/md/ic_search';
import { ic_delete } from 'react-icons-kit/md/ic_delete';
import {ic_monetization_on} from 'react-icons-kit/md/ic_monetization_on';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import NavBar from '../components/NavBar';
import FrTable from '../components/FrTable';
import FrTextInput from '../components/FrTextInput';
import FrSelect from '../components/FrSelect';
import UserOptions from '../components/UserOptions';
import FrLoading from '../components/FrLoading';
import FrDatePicker from '../components/FrDatePicker';
import FooterDelphus from '../components/FooterDelphus';
import AutoComp from '../components/AutoComp';
import Dialog from '@material-ui/core/Dialog';


import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString, getUserCode } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';
import { mCompetencia } from '../utils/masks';

const swal = withReactContent(Swal)

function FaturamentoEmpresa(props) {
  const [data, setData] = useState([])
  const [dataEmpresas, setDataEmpresas] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [emp, setEmp] = useState(0)
  const [selected, setSelected] = useState([])
  const [selectedEmpresas, setSelectedEmpresas] = useState([])
  const [dataCobranca, setDataCobranca] = useState({})
  const [showModalCobranca, setShowModalCobranca] = useState(false)
  const [showModalEmpresas, setShowModalEmpresas] = useState(false)
  const [comboEmp, setComboEmp] = useState([{ value: '', display: '' }])
  const [comboCte, setComboCte] = useState([{ value: '', display: '' }])

  const handleChangeModal = (e) => {
    e.preventDefault();

    const auxValues = { ...dataCobranca };
    auxValues[e.target.name] = e.target.value;
    setDataCobranca(auxValues);
  }
  const handleChangeModalEmpresas = (e) => {
    e.preventDefault();

    const auxValues = [ ...dataEmpresas ];
    
    setDataEmpresas(auxValues);
    console.log(dataEmpresas, e.target.id)
  }

  const columns = [
    { id: 'fk_cte', numeric: false, label: 'Contrato', align: 'left', minWidth: 200 },
    { id: 'nomecli', numeric: false, label: 'Empresa', align: 'left', minWidth: 150 },
    // { id: 'formatdata_emissao', numeric: false, label: 'Emissão', align: 'left', minWidth: 200 },
    { id: 'formatdata_vencimento', numeric: false, label: 'Vencimento', align: 'left', minWidth: 200 },
    { id: 'competencia', numeric: false, label: 'Competencia', align: 'left', minWidth: 200 },
    { id: 'valor_total', numeric: false, label: 'Valor Total', align: 'left', minWidth: 200 },

  ]
  // Empresa | Contrato | Valor | Vencimento | Qtde Beneficiários
  const columnsEmpresas = [
    { id: 'pk_cte', numeric: false, label: 'Contrato', align: 'left', minWidth: 200 },
    { id: 'razao_social', numeric: false, label: 'Empresa', align: 'left', minWidth: 150 },
    { id: 'valor_total', numeric: false, label: 'Valor Total', align: 'left', minWidth: 200 },
    { id: 'qtd_beneficiarios', numeric: false, label: 'QTD Beneficiários', align: 'left', minWidth: 200 },
    { id: 'vencimento', numeric: false, label: 'Vencimento', align: 'left', minWidth: 200, render: 'dateInput' },
  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      setComboEmp(await api.getComboData('empresas'))
      setenableAdd(await api.getAcessos('faturamento_empresa', 'Inclusao'))
      setenableEdit(await api.getAcessos('faturamento_empresa', 'Alteracao'))
      setenableDel(await api.getAcessos('faturamento_empresa', 'Exclusao'))


      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        getData(event)
      }
    }

    fetchData()
  }, [])

  useEffect(() => {
    async function fetch() {
      if (dataCobranca.fk_emp) {
        setComboCte(await api.getComboDataWhere('contratos_empresas', "?fk_emp=" + dataCobranca.fk_emp))
      }
    }
    
    fetch()
  }, [dataCobranca.fk_emp])

  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    queryObject.buscar = true
    setFiltered(true)
    window.history.replaceState({ filtered: true }, 'filter', "/salute/faturamento_empresa?" + objectToQueryString(queryObject));
    swal.fire({
      html: <FrLoading text="Buscando dados..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    api.get('/faturamento_empresa', { params: queryObject }).then(r => {
      setData(r.data)
      swal.close()
    })
  }

  useEffect(() => {
    const fetchEmp = async () => {
      const auxValues = { ...filter };
      auxValues["fk_emp"] = emp;
      auxValues["nomeemp"] = ''
      if (emp > 0) {
        await api.get("/empresas?pk_emp=" + emp).then((r) => {
          if (r.data[0])
            auxValues["nomeemp"] = r.data[0].razao_social;
        });
      }
      setFilter(auxValues);
    };
    fetchEmp();
  }, [emp]);


  function clearForm(e) {
    e.preventDefault();
    window.history.replaceState({ filtered: false }, 'filter', '/salute/faturamento_empresa');
    document.getElementById('searchForm').reset()
    setFilter({})
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    auxValues[e.target.name] = e.target.value;
    setFilter(auxValues);
  };

  const mostraModalCobranca = (e) => {
    e.preventDefault();
    setShowModalCobranca(true)
    setDataCobranca({})
  }

  const mostraModalEmpresas = (e) => {
    e.preventDefault();
    let hoje = new Date()
    swal.fire({
      html: <FrLoading text="Buscando dados..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
    })
    setShowModalCobranca(false)
    api.get('/empresas/faturamento?data_fim='+hoje.toISOString().split('T')[0]+'&competencia='+dataCobranca.competencia.replace('/', '')+'&vencimento='+dataCobranca.vencimento).then(r=>{ 
      setShowModalEmpresas(true)
      setDataEmpresas(r.data)
      console.log(r.data)
      swal.close()
    })
  }

  const geraCobranca = (e) => {
    e?.preventDefault();
    console.log(dataEmpresas)
    if (selectedEmpresas.length == 0) {
      return swal.fire('Erro!', 'Selecione os registros para a geração.', 'error');
    }
    // if(!dataCobranca.fk_emp || !dataCobranca.competencia || !dataCobranca.vencimento){
    //   return swal.fire('Erro!', 'Preencha todos os dados', 'error')
    // }
    let auxValues = [...dataEmpresas]
    auxValues = auxValues.filter(item => selectedEmpresas.includes(item.pk_cte))

    setShowModalCobranca(false)
    
    // swal.fire({
    //   html: <FrLoading text="Gerando Cobranças..." />,
    //     showConfirmButton: false,
    //     allowOutsideClick: false,
    //     allowEscapeKey: false
    // })

    console.log(auxValues)

    api.post('faturamento_empresa/gerar', {dataEmpresas: auxValues, competencia: dataCobranca.competencia, fk_usu: getUserCode()}).then(r => {
      console.log(r.data)
      if (r.data == 'done'){
        swal.fire("Sucesso!", 'Cobranças geradas com sucesso.', 'success')
      } else if (r.data == 'Nenhum contrato elegivel encontrado') {
        swal.fire("Erro!", 'Nenhum contrato elegivel encontrado.', 'error').then(() => {
          setShowModalCobranca(false)
        })

      } else {
        swal.fire("Erro!", 'Falha ao gerar cobranças.', 'error').then(() => {
          setShowModalCobranca(false)
        })
        
      }
    })
  }

  

  return (
    <div className="Manut">
      <NavBar />
      <div>
        <Dialog aria-labelledby="simple-dialog-title" open={showModalCobranca} maxWidth={'md'}>
         
          <div className="modalContent">
            
              <>
                
                <FrTextInput
                  value={mCompetencia(dataCobranca.competencia) || ''}
                  style={{ width: 100 }}
                  name="competencia"
                  id="competencia"
                  color="#333333"
                  label="Competência"
                  variant="outlined"
                  size="small"
                  onChange={handleChangeModal}
                />

                <FrDatePicker
                  value={(dataCobranca.vencimento || '').split('T')[0]}
                  name="vencimento"
                  id="vencimento"
                  color="#49573B"
                  label="Vencimento"
                  variant="outlined"
                  size="small"
                  style={{ width: 190 }}
                  onChange={handleChangeModal}
                />
                <br/>
                <FrTextInput
                  value={dataCobranca.observacoes || ''}
                  style={{ width: 706 }}
                  name="observacoes"
                  id="observacoes"
                  color="#333333"
                  label="Observações"
                  variant="outlined"
                  size="small"
                  onChange={handleChangeModal}
                />
              </>
          

          </div>
        <div className="FrModalFooter">
          <div className="FrModalButtonsDiv">
          <button onClick={mostraModalEmpresas}> Gerar </button>
            <button onClick={() => {setShowModalCobranca(false)}}> Fechar </button>
          </div>
        </div>
        </Dialog>
      </div>
      <div>
        <Dialog aria-labelledby="simple-dialog-title" open={showModalEmpresas} maxWidth={'lg'}>
         
          <div className="modalContent">
        
            <div className="tableDiv">
              <FrTable 
                regName="empresas" 
                columns={columnsEmpresas} 
                searched={filtered} 
                codeName="pk_cte" 
                page={'empresas'} 
                data={dataEmpresas} 
                modal
                readOnly
                selected={selectedEmpresas}
                setSelected={setSelectedEmpresas}
                mostraCheck="S"
                enableEdit={enableEdit} 
                enableDel={enableDel} 
                setData={setDataEmpresas}
                
              />
            </div>  
          </div>
        <div className="FrModalFooter">
          <div className="FrModalButtonsDiv">
          <button onClick={geraCobranca}> Gerar </button>
            <button onClick={() => {setShowModalEmpresas(false)}}> Fechar </button>
          </div>
        </div>
        </Dialog>
      </div>
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Faturamento Empresas</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              <FrTextInput
                value={filter.pk_cte || ''}
                style={{ width: 100 }}
                name="pk_cte"
                id="pk_cte"
                color="#333333"
                label="Nº Contrato"
                variant="outlined"
                size="small"
                onChange={handleChange}
                autoFocus
              />
              <AutoComp
                value={filter.nomeemp || ""}
                valor={emp}
                width={350}
                name="fk_emp"
                id="fk_emp"
                label='Cliente'
                data={comboEmp}
                setValue={setEmp}
                tabela={'empresas'}
                chave={'razao_social'}
                form={'searchForm'}
                manut={'contratos_empresas'}
              />
              
              <FrDatePicker
                value={(filter.datainivenc || '').split('T')[0]}
                name="datainivenc"
                id="datainivenc"
                color="#49573B"
                label="Período Vencimento"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.datafimvenc || '').split('T')[0]}
                name="datafimvenc"
                id="datafimvenc"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />


            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              <button onClick={mostraModalCobranca}>
                <Icon icon={ic_monetization_on} size={18} />
                Gerar Cobrança
              </button>
              {enableAdd !== 'S' ? '' :
                <Link to="/salute/faturamento_empresa/registro">
                  <button >
                    <Icon icon={ic_add_box} size={18} />
                    Novo Registro
                  </button>
                </Link>}
            </div>
          </form>
        </div>
        <br />
        <div className="tableDiv">
          <FrTable 
            regName="faturamento_empresa" 
            columns={columns} 
            searched={filtered} 
            codeName="pk_fat" 
            page={'FaturamentoEmpresa'} 
            data={data} 
            imprimeFatura
            enableEdit={"N"} 
            cancelaFatura 
            baixaNtf
            enableDel={enableDel} 
            visualizar
            enviaFaturaEmail
          />
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default FaturamentoEmpresa;
